import { isDesktop } from 'react-device-detect';
import FreespinWinController from '../../controllers/freespin/FreespinWinController';
import MainGridController from '../../controllers/grid/MainGridController';
import { COMPONENTS } from '../../lib/constants';
import { FreespinWinGrid } from './FreespinWinGrid';
let scale = isDesktop ? 1 : 2;
export const FreespinWinView = {
	name: COMPONENTS.FREE_SPIN_WIN,
	child: true,
	position: {
		x: 0,
		y: 0
	},
	controllers: [
		{
			Controller: FreespinWinController,
			name: 'FreespinWinController',
			config: {
				holder: 'freespin_win_holder'
			}
		},
		{
			Controller: MainGridController,
			name: 'FreespinWinGrid',
			config: FreespinWinGrid
		}
	],
	components: [
		{
			name: 'freespin_win_holder',
			type: 'Sprite',
			components: [
				{
					name: 'bg',
					type: 'Sprite',
					img: 'external_bonus_bg',
					position: { x: 0, y: 0 },
					scale: { x: scale, y: scale }
				},
				{
					name: 'header',
					type: 'CustomText',
					text: 'QUEST_PROMPT_HEADER',
					position: { x: 634 / 2, y: 18 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_WIN_TITLE',
					type: 'Text',
					text: 'FREE_SPIN_WIN_TITLE',
					position: { x: 634 / 2, y: 120 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_TOTAL_AMOUNT',
					type: 'CustomText',
					text: 'FREE_SPIN_TOTAL_AMOUNT',
					position: { x: 634 / 2 + 10, y: 240 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_TOTAL_TEXT',
					type: 'CustomText',
					text: 'FREE_SPIN_TOTAL_TEXT',
					position: { x: 634 / 2 + 10, y: 350 },
					anchor: { x: 0.5, y: 0 }
				},
				{
					name: 'FREE_SPIN_BTN',
					type: 'ActionButton',
					bg: 'notif_btn',
					text: 'FREE_SPIN_BTN',
					position: { x: 634 / 2, y: 510 }
				}
			]
		}
	]
};
